import type { DailyReportStatus } from "@centerline/core/viewer";

/** Words people see on status badges. */
export function statusLabel(r: { status: DailyReportStatus; returnedAt?: string }): string {
  if (r.status === "submitted") return "Awaiting approval";
  if (r.status === "approved") return "Approved";
  return r.returnedAt ? "Sent back" : "Draft";
}
